module.exports = __webpack_public_path__ + "images/category_lp/earphone/assessment_achievements/4_817ba4dc193fe167b860d7f0283bb1e6.jpg";